import { FormField } from '@zillow/constellation-10';

import { WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

import PetsAllowedFormField from './PetsAllowedFormField';

const FormSectionContainer = () => {
  return (
    <div data-testid="FormSectionContainer">
      <WizardFormSectionContainer data-testid="FormSectionContainer">
        <WizardHeading level={1} textStyle="heading-sm">
          Tell us about your pet policy
        </WizardHeading>

        <FormField>
          <PetsAllowedFormField />
        </FormField>
      </WizardFormSectionContainer>
    </div>
  );
};

export default FormSectionContainer;
